export const PATENT_APPLICATION = "Patent Application";
export const OFFICE_ACTION = "Office Action";
export const GENERAL = "General";

/** Category whose dropdown values resolve to individual drawings (with thumbnails) instead of documents. */
export const DRAWINGS_CATEGORY = "Drawings";

export const DOCUMENT_CATEGORIES = {
  [PATENT_APPLICATION]: ["Disclosure", "Client Conversation", DRAWINGS_CATEGORY, "Prior Art"],
  [OFFICE_ACTION]: ["Office Action", "Prior Art", "Client Conversation", "Specification", DRAWINGS_CATEGORY],
  [GENERAL]: ["Context Materials", "Client Conversation", DRAWINGS_CATEGORY],
} as const;

export type SessionMode = keyof typeof DOCUMENT_CATEGORIES;

export const CATEGORY_ID_PREFIX = "category:";
